/**
 * Tiny synthesized sounds for the bridge scene. Off unless the patient turns them on;
 * nothing is downloaded, every sound is a few oscillator notes.
 */

const KEY = 'remind_sound';
let ctx: AudioContext | null = null;

export function soundOn(): boolean {
  try {
    return localStorage.getItem(KEY) === 'on';
  } catch {
    return false;
  }
}

export function setSoundOn(on: boolean) {
  try {
    localStorage.setItem(KEY, on ? 'on' : 'off');
  } catch { /* private mode: stays off */ }
}

function audio(): AudioContext | null {
  if (!soundOn()) return null;
  try {
    ctx ??= new AudioContext();
    if (ctx.state === 'suspended') void ctx.resume();
    return ctx;
  } catch {
    return null;
  }
}

function drop(a: AudioContext, at: number, from: number, to: number, vol = 0.12, len = 0.18) {
  const o = a.createOscillator();
  const g = a.createGain();
  o.type = 'sine';
  o.frequency.setValueAtTime(from, at);
  o.frequency.exponentialRampToValueAtTime(to, at + len);
  g.gain.setValueAtTime(0.0001, at);
  g.gain.exponentialRampToValueAtTime(vol, at + 0.01);
  g.gain.exponentialRampToValueAtTime(0.0001, at + len);
  o.connect(g).connect(a.destination);
  o.start(at);
  o.stop(at + len + 0.02);
}

export type Sound = 'drip' | 'cascade' | 'chirp';

export function play(sound: Sound) {
  const a = audio();
  if (!a) return;
  const t = a.currentTime + 0.01;
  if (sound === 'drip') drop(a, t, 880, 320);
  if (sound === 'chirp') {
    drop(a, t, 2400, 3200, 0.05, 0.07);
    drop(a, t + 0.09, 2600, 3400, 0.05, 0.07);
  }
  if (sound === 'cascade') {
    [784, 659, 587, 523, 440, 392].forEach((f, i) => drop(a, t + i * 0.09, f * 1.6, f, 0.07, 0.35));
  }
}
